import { metaHelper, type BuilderMeta } from '@customerio/dryad';
import { createBuilderHook } from '@customerio/dryad-react';
import { OBJECT_FILTER_FORMAT, OBJECT_FILTER_MAX_DEPTH, objectFilterAdapter } from './object-filter-format';

export type ObjectFilterBuilderMeta = BuilderMeta & { attributeNames: readonly string[] };

export const objectFilterBuilder = createBuilderHook({
  formatAdapters: { [OBJECT_FILTER_FORMAT]: objectFilterAdapter },
  maxDepth: OBJECT_FILTER_MAX_DEPTH,
  meta: metaHelper<ObjectFilterBuilderMeta>(),
});
